import { styled } from "@mui/material/styles"

export interface LineSliderInputProps {
    isDisabled: boolean
    rangeValue: number
    thumbHeight: number
}

/**
 * Styling-only props. They must not reach the <input>, otherwise React warns about
 * unrecognized DOM attributes. The previous filter checked for "dragging", which is not a
 * prop name here, so in practice nothing was filtered out at all.
 */
const STYLE_ONLY_PROPS: string[] = ["isDisabled", "rangeValue", "thumbHeight"]

export const LineSliderInput = styled("input", {
    shouldForwardProp: (prop) => !STYLE_ONLY_PROPS.includes(prop as string),
})<LineSliderInputProps>(({ theme, thumbHeight, isDisabled, rangeValue }) => ({
    width: "100%",
    appearance: "none",
    height: 2,
    borderRadius: "2px",
    outline: "none",
    transition: "background 0.2s",
    cursor: isDisabled ? "not-allowed" : "col-resize",
    opacity: isDisabled ? 0.6 : 1,
    background: `linear-gradient(to right, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} ${rangeValue}%, ${theme.palette.grey[500]} ${rangeValue}%, ${theme.palette.grey[500]} 100%)`,
    pointerEvents: "none",

    "&::-webkit-slider-thumb": {
        appearance: "none",
        width: "3px",
        height: `${thumbHeight}px`,
        background: theme.palette.error.main,
        cursor: "col-resize",
        border: "none",
        borderRadius: "1px",
        transform: "translateY(50%)",
        pointerEvents: "auto",
        position: "relative",
        top: "50%",
    },

    "&::-moz-range-thumb": {
        width: "3px",
        height: `${thumbHeight}px`,
        background: theme.palette.error.main,
        cursor: "col-resize",
        border: "none",
        borderRadius: "1px",
        transform: "translateY(-50%)",
        pointerEvents: "auto",
        position: "relative",
        top: "50%",
    },
}))
